import React from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import Alert from "@material-ui/lab/Alert";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { BsCheck } from "react-icons/bs";
import { useHistory } from "react-router-dom";
import { ButtonRow, FormStepper, theme } from "@omnigenbiodata/react";
import InnerLayout from "../../../../../../../../layout/Inner";
import Panel from "../../../../../../../../components/layout/Panel";
import { useAppDispatch } from "../../../../../../../../store";
import { batchCreateForward } from "../../../../../../../../store/batchCreate";
import ROUTES from "../../../../../../../../core/constants/routes.constants";
import FORMS, {
  MESSAGES,
} from "../../../../../../../../core/constants/forms.constants";
import {
  SampleTypeCodeEnum,
  SampleTypeNameEnum,
} from "../../../../../../../../core/api/lab.types";

function SampleTypeScene() {
  const dispatch = useAppDispatch();
  const history = useHistory();

  const validationSchema = yup.object({
    sampleType: yup.string().required(MESSAGES.sampleTypeRequired),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      sampleType: "",
      samples: [],
    },
    validateOnMount: true,
    validationSchema,
    onSubmit: (values) => {
      dispatch(batchCreateForward(values));
      history.push(ROUTES.batchesCreatePrimaryTubes);
    },
  });

  return (
    <InnerLayout>
      <form onSubmit={formik.handleSubmit}>
        <Box mb={2}>
          <Typography variant="h4" component="h1" align="center" paragraph>
            Sample Processing
          </Typography>
          <FormStepper steps={FORMS.PROCESSING_STEPS} activeStep={0} />
        </Box>
        <Panel
          mb={6}
          title="Sample Type"
          intro="Please select the sample type you are processing:"
        >
          {formik.errors.sampleType && formik.touched.sampleType && (
            <Box mb={2}>
              <Alert severity="error">{formik.errors.sampleType}</Alert>
            </Box>
          )}

          <Grid container spacing={2}>
            {Object.values(SampleTypeCodeEnum).map((sampleKey) => (
              <Grid item xs={12} lg={4} key={sampleKey}>
                <Button
                  variant={
                    formik.values.sampleType === sampleKey
                      ? "contained"
                      : "outlined"
                  }
                  color="default"
                  size="small"
                  fullWidth
                  onClick={() => {
                    formik.setFieldValue(
                      "sampleType",
                      sampleKey as SampleTypeCodeEnum
                    );
                  }}
                  endIcon={
                    formik.values.sampleType === sampleKey ? (
                      <BsCheck size={30} color={theme.palette.primary.main} />
                    ) : undefined
                  }
                  centerRipple
                >
                  {SampleTypeNameEnum[sampleKey]}
                </Button>
              </Grid>
            ))}
          </Grid>
        </Panel>
        <ButtonRow
          showBack={false}
          showForward={formik.isValid}
          buttonSize="small"
        />
      </form>
    </InnerLayout>
  );
}

export default SampleTypeScene;
